<template>
  <base-widget title="Block Dashboard">
    <v-icon
      class="mb-3"
      x-large
    >
      mdi-laptop
    </v-icon>

    <v-card-text class="text-center">
      Block Dashboard created by John
      <br><br>
      Special thanks to you for supporting Open Source Software
    </v-card-text>
  </base-widget>
</template>

<script>
  export default {
    name: 'WidgetsBlockDashboard',
  }
</script>
